import React from 'react';
import { MapPin, Phone, Mail, Facebook } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-charcoal-900 text-charcoal-300 py-16 lg:py-24 border-t border-charcoal-800" data-id="element-46">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-47">
        {/* Brand row */}
        <div className="mb-14 max-w-2xl" data-id="element-48">
          <a href="#" className="inline-flex items-center mb-6" aria-label="Dennis Martin DDS — Home" data-id="element-49">
            <img src="https://dennismartindds.com/index_htm_files/236@2x.png" alt="Dennis Martin DDS" className="h-16 w-auto" data-id="element-50" />
          </a>
          <p className="text-charcoal-400 leading-relaxed text-lg" data-id="element-51">
            Family-oriented dental care for Lincoln &amp; Waverly since 2001. We
            go the extra smile.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-52">
          {/* Lincoln Office */}
          <div data-id="element-53">
            <h4 className="text-white font-serif font-medium text-lg mb-6 flex items-center gap-2" data-id="element-54">
              <span className="w-2 h-2 rounded-full bg-sage" data-id="element-55"></span>
              Lincoln Office
            </h4>
            <ul className="space-y-4 text-charcoal-300" data-id="element-56">
              <li className="flex items-start gap-3" data-id="element-57">
                <MapPin size={18} className="text-sage shrink-0 mt-1" data-id="element-58" />
                <span data-id="element-59">
                  Lincoln, NE
                  <br data-id="element-60" />
                  <span className="text-charcoal-500 text-sm" data-id="element-61">
                    Mon · Wed · Fri
                  </span>
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-62">
                <Phone size={18} className="text-sage shrink-0" data-id="element-63" />
                <a href="tel:+14024887020" className="hover:text-white transition-colors" data-id="element-64">
                  402-488-7020
                </a>
              </li>
            </ul>
          </div>

          {/* Waverly Office */}
          <div data-id="element-65">
            <h4 className="text-white font-serif font-medium text-lg mb-6 flex items-center gap-2" data-id="element-66">
              <span className="w-2 h-2 rounded-full bg-coral" data-id="element-67"></span>
              Waverly Office
            </h4>
            <ul className="space-y-4 text-charcoal-300" data-id="element-68">
              <li className="flex items-start gap-3" data-id="element-69">
                <MapPin size={18} className="text-sage shrink-0 mt-1" data-id="element-70" />
                <span data-id="element-71">
                  Waverly, NE
                  <br data-id="element-72" />
                  <span className="text-charcoal-500 text-sm" data-id="element-73">Tue · Thu</span>
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-74">
                <Phone size={18} className="text-sage shrink-0" data-id="element-75" />
                <a href="tel:+14027862221" className="hover:text-white transition-colors" data-id="element-76">
                  402-786-2221
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-77">
            <h4 className="text-white font-serif font-medium text-lg mb-6" data-id="element-78">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-79">
              <li data-id="element-80">
                <a href="#about" className="hover:text-sage transition-colors" data-id="element-81">
                  Our Mission
                </a>
              </li>
              <li data-id="element-82">
                <a href="#services" className="hover:text-sage transition-colors" data-id="element-83">
                  Dental Treatments
                </a>
              </li>
              <li data-id="element-84">
                <a href="#team" className="hover:text-sage transition-colors" data-id="element-85">
                  About the Doctor
                </a>
              </li>
              <li data-id="element-86">
                <a href="#testimonials" className="hover:text-sage transition-colors" data-id="element-87">
                  Patient Reviews
                </a>
              </li>
              <li data-id="element-88">
                <a href="#book" className="hover:text-sage transition-colors" data-id="element-89">
                  New Patient Special
                </a>
              </li>
            </ul>
          </div>

          {/* Office Hours */}
          <div data-id="element-90">
            <h4 className="text-white font-serif font-medium text-lg mb-6" data-id="element-91">
              Office Hours
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-92">
              <li className="flex justify-between border-b border-charcoal-800 pb-2" data-id="element-93">
                <span data-id="element-94">Mon - Thu</span>
                <span className="text-white" data-id="element-95">8:00 - 5:00</span>
              </li>
              <li className="flex justify-between border-b border-charcoal-800 pb-2" data-id="element-96">
                <span data-id="element-97">Friday</span>
                <span className="text-white" data-id="element-98">8:00 - 2:00</span>
              </li>
              <li className="flex justify-between border-b border-charcoal-800 pb-2" data-id="element-99">
                <span data-id="element-100">Sat - Sun</span>
                <span className="text-white" data-id="element-101">Closed</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-6" data-id="element-102">
              <a href="#" className="w-10 h-10 rounded-full bg-charcoal-800 flex items-center justify-center hover:bg-sage hover:text-white transition-colors" aria-label="Facebook" data-id="element-103">
                <Facebook size={16} data-id="element-104" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-charcoal-800 flex items-center justify-center hover:bg-sage hover:text-white transition-colors" aria-label="Email" data-id="element-105">
                <Mail size={16} data-id="element-106" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-charcoal-800 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-charcoal-500" data-id="element-107">
          <p data-id="element-108">
            © {new Date().getFullYear()} Dennis Martin DDS. All rights
            reserved.
          </p>
          <p className="text-charcoal-600 italic" data-id="element-109">We go the extra Smile!</p>
        </div>
      </div>
    </footer>;
}